import { createRouter, createWebHistory } from "vue-router";
import Index from "@/components/index";

const routes = [
  {
    path: "/:code",
    name: "default",
    meta: {
      title: "Dashboard",
    },
    component: Index,
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;